// Route definitions only; the schemas they refer to stay out of the web bundle.
import type { z } from 'zod';
import { defineRoute } from './route.ts';
import type {
  activityQuery,
  activityResponse,
  adminUser,
  adminUsersResponse,
  appearanceBody,
  createUserBody,
  createUserResponse,
  deleteUserBody,
  discogsTestResponse,
  editUserBody,
  linkIdentityBody,
  passwordLinkResponse,
  roleBody,
  setPasswordBody,
  setPasswordState,
  siteDefaults,
  siteDefaultsResponse,
  systemStatusResponse,
  vitalsBody,
} from './admin.ts';

type Ok = z.ZodObject<{ ok: z.ZodLiteral<true> }>;

export const adminListUsers = defineRoute<{ response: typeof adminUsersResponse }>()({ method: 'GET', path: '/api/admin/users' });
export const adminCreateUser = defineRoute<{ body: typeof createUserBody; response: typeof createUserResponse }>()({ method: 'POST', path: '/api/admin/users', status: 201 });
export const adminEditUser = defineRoute<{ body: typeof editUserBody; response: typeof adminUser }>()({ method: 'PATCH', path: '/api/admin/users/:id' });
export const adminSetRole = defineRoute<{ body: typeof roleBody; response: typeof adminUser }>()({ method: 'PUT', path: '/api/admin/users/:id/role' });
export const adminDisableUser = defineRoute<{ response: typeof adminUser }>()({ method: 'POST', path: '/api/admin/users/:id/disable' });
export const adminEnableUser = defineRoute<{ response: typeof adminUser }>()({ method: 'POST', path: '/api/admin/users/:id/enable' });
export const adminDeleteUser = defineRoute<{ body: typeof deleteUserBody; response: Ok }>()({ method: 'DELETE', path: '/api/admin/users/:id' });
export const adminPasswordLink = defineRoute<{ response: typeof passwordLinkResponse }>()({ method: 'POST', path: '/api/admin/users/:id/password-link' });
export const adminLinkIdentity = defineRoute<{ body: typeof linkIdentityBody; response: typeof adminUser }>()({ method: 'POST', path: '/api/admin/users/:id/oidc-identity' });
export const adminStatus = defineRoute<{ response: typeof systemStatusResponse }>()({ method: 'GET', path: '/api/admin/status' });
export const adminDiscogsTest = defineRoute<{ response: typeof discogsTestResponse }>()({ method: 'POST', path: '/api/admin/discogs/test' });
export const adminGetSiteDefaults = defineRoute<{ response: typeof siteDefaultsResponse }>()({ method: 'GET', path: '/api/admin/site-defaults' });
export const adminSetSiteDefaults = defineRoute<{ body: typeof siteDefaults; response: typeof siteDefaultsResponse }>()({ method: 'PUT', path: '/api/admin/site-defaults' });
export const adminSetAppearance = defineRoute<{ body: typeof appearanceBody; response: typeof appearanceBody }>()({ method: 'PUT', path: '/api/admin/appearance' });
export const adminActivity = defineRoute<{ query: typeof activityQuery; response: typeof activityResponse }>()({ method: 'GET', path: '/api/admin/activity' });

/** Page speed from the browser, without personal data. */
export const postVitals = defineRoute<{ body: typeof vitalsBody; response: z.ZodNull }>()({ method: 'POST', path: '/api/vitals', status: 204 });

/** The set-password page: GET /auth/set-password?token= moves the token into a cookie first. */
export const SET_PASSWORD_LINK_PATH = '/auth/set-password';
export const getSetPassword = defineRoute<{ response: typeof setPasswordState }>()({ method: 'GET', path: '/api/auth/set-password' });
export const setPassword = defineRoute<{ body: typeof setPasswordBody; response: Ok }>()({ method: 'POST', path: '/api/auth/set-password' });
